module.exports = __webpack_public_path__ + "img/game-place-runes-bright.0c9d6c9b.png";